<template>
    <div class="page-body add-extended-family-modal">
        <NoButtonModal :open="true">
            <div class="modal-list-third-party-app section-body">
                <div class="modal-content-header d-flex justify-content-between align-items-center ps-4 pe-2 py-1">
                    <span class="label-app-list-header">Add Extended Family</span>
                </div>

                <ValidationObserver v-if="!loading" ref="form">
                    <form @submit.prevent="validateAndEmit" style="box-shadow: none" class="p-0">
                        <div class="flex flex-column items-center">
                            <div
                                v-for="(member, index) in familyMembers"
                                :key="member.id"
                                class="position-relative flex flex-column w-80 mx-auto"
                                style="gap: 10px"
                            >
                                <img
                                    v-if="familyMembers.length > 1"
                                    src="@/assets/px/cross-icon.svg"
                                    class="cross-btn"
                                    height="20"
                                    @click="removeFamilyMember(index)"
                                    v-b-tooltip.hover.bottom="'Remove'"
                                    alt="remove"
                                />

                                <div class="flex gap-4">
                                    <span class="w-50">
                                        <label class="add-new-app-label my-1">First Name</label>
                                        <Input
                                            label=""
                                            type="text"
                                            name="First Name"
                                            placeholder="First Name"
                                            v-model="member.first_name"
                                            required
                                        />
                                    </span>
                                    <span class="w-50">
                                        <label class="add-new-app-label my-1">Last Name</label>
                                        <Input
                                            label=""
                                            type="text"
                                            name="Last Name"
                                            placeholder="Last Name"
                                            v-model="member.last_name"
                                            required
                                        />
                                    </span>
                                </div>

                                <div class="flex flex-column">
                                    <label class="add-new-app-label w-20 my-1">Email</label>
                                    <Input
                                        label=""
                                        type="email"
                                        name="Email"
                                        placeholder="Email"
                                        rules="email"
                                        v-model="member.email"
                                        @input="member.errors.email = null"
                                        required
                                    />
                                    <span v-if="member.errors.email" class="text-danger">{{
                                        member.errors.email
                                    }}</span>
                                </div>

                                <hr v-if="index !== familyMembers.length - 1" class="w-full my-4 border-gray-300" />
                            </div>

                            <div class="w-80 mx-auto mt-3">
                                <button
                                    type="button"
                                    class="text-button no-bg weight-600"
                                    style="padding: 0; width: fit-content; color: #5057c3"
                                    :style="{ cursor: familyMembers.length >= maxFamilyLimit ? 'not-allowed' : '' }"
                                    @click="addMoreFamilyMember"
                                >
                                    <span class="material-icons" style="color: #5057c3">add</span> Add More
                                </button>
                            </div>
                        </div>

                        <div class="w-80 mx-auto text-center">
                            <button type="submit" class="primary btn-save">Send Invite</button>
                            <button type="button" class="no-bg btn-cancel px-4" @click="$emit('close')">Cancel</button>
                        </div>
                    </form>
                </ValidationObserver>

                <div
                    v-if="loading"
                    class="d-flex flex-column justify-content-center align-items-center loader-main"
                    style="min-height: 15rem"
                >
                    <b-spinner variant="primary" class="add-list-function-loader mb-1"></b-spinner>
                    <span class="ms-3">Loading ...</span>
                </div>
            </div>
        </NoButtonModal>
    </div>
</template>

<script>
    import NoButtonModal from '@/components/general/modals/NoButtonModal';
    import { ValidationObserver } from 'vee-validate';

    export default {
        name: 'AddExtendedFamilyModal',
        components: { NoButtonModal, ValidationObserver },
        props: {
            clientId: {
                type: [Number, String],
                default: 0,
            },
            existingExtendedFamilyError: {
                type: Array,
            },
        },
        data() {
            return {
                loading: false,
                familyMembers: [this.createEmptyMember()],
                maxFamilyLimit: 4,
            };
        },
        methods: {
            generateUniqueId() {
                return Math.random().toString(36).slice(2, 11);
            },
            createEmptyMember() {
                return {
                    id: this.generateUniqueId(),
                    first_name: '',
                    last_name: '',
                    email: '',
                    errors: {
                        email: null,
                    },
                };
            },
            addMoreFamilyMember() {
                if (this.familyMembers.length < this.maxFamilyLimit) {
                    this.familyMembers.push(this.createEmptyMember());
                }
            },
            removeFamilyMember(index) {
                this.familyMembers.splice(index, 1);
            },
            async validateAndEmit() {
                const form = this.$refs.form;
                const isFormValid = await form.validate();

                if (!isFormValid) {
                    return;
                }

                let isValid = true;

                const emailRoleData = [];
                const emailMap = {};

                this.familyMembers.forEach((member) => {
                    member.errors.email = null;
                    member.errors.role = null;

                    const { first_name, last_name } = member;
                    const email = member.email.trim().toLowerCase();

                    if (email) {
                        if (emailMap[email]) {
                            member.errors.email = 'Duplicate email not allowed.';
                            isValid = false;
                        } else {
                            emailMap[email] = true;
                        }
                    }

                    if (!member.errors.email) {
                        emailRoleData.push({ first_name, last_name, email });
                    }
                });

                if (isValid) {
                    this.loading = true;
                    this.$emit('submit', emailRoleData);
                }
            },
            applyApiErrors(emailErrors) {
                this.loading = false;

                this.familyMembers.forEach((member) => {
                    const email = member.email.trim().toLowerCase();
                    if (emailErrors.includes(email)) {
                        member.errors.email = 'Email already exists.';
                    }
                });
            },
        },
        watch: {
            existingExtendedFamilyError(newVal) {
                if (Array.isArray(newVal) && newVal.length) {
                    this.applyApiErrors(newVal);
                }
            },
        },
    };
</script>

<style scoped>
    .label-app-list-header {
        font-family: Roboto;
        font-weight: 500;
        font-size: 1.5rem;
    }

    .modal-content-header {
        font-size: 18px;
        color: #2e3343;
        margin: 0 0 20px;
        background-color: #f1f7ff;
    }

    .btn-save {
        border-radius: 10px;
        background: #5155c3 !important;
        box-shadow: 0px 10px 5px 0px rgba(0, 0, 0, 0.03);
    }

    button.no-bg:hover {
        background: none;
    }

    .btn-cancel,
    .btn-cancel:hover {
        background: white !important;
        border-radius: 10px;
        border: 2px solid #ac2734;
    }

    .text-danger {
        color: red;
        font-size: 0.9rem;
        font-weight: 600;
    }
</style>

<style>
    .add-extended-family-modal .modal__content {
        padding: 0;
        border-radius: 10px;
        width: 45rem !important;
    }

    .add-extended-family-modal .modal__content input {
        border-radius: 10px !important;
    }

    .cross-btn {
        position: absolute;
        right: -5px;
        cursor: pointer;
    }
</style>
